















import Vue from "vue";

export default Vue.extend({
  name: "navbar",
  components: {},
  data: () => ({}),
  methods: {}
});
